import { createRecipe } from './runtime';

const proseConfig = {"name":"prose"}

export const prose = /* @__PURE__ */ createRecipe(proseConfig)